module.exports = __webpack_public_path__ + "img/group_plan_success.4af82835.png";